import { FC, useEffect } from 'react';
import { Box, Grid, FormControl, TextField, Select, MenuItem, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import React from 'react';
import { CSF } from '../../cargoShippingFeeManagement.classes';

interface IProps {
    cargoShipmentList?: any;
    regionList?: any;
    statusList?: any;
    paymentList?: any;
    filterInput?: any;
    chipList?: any;
    onClose?: any;
    cargoNameList?: any;
    getCargoList?: any;
    deliveryTypeList?: any;
    getDeliveryTypeList?: any;
}

export const SCUICargoFilter: FC<IProps> = ({
    cargoShipmentList,
    regionList,
    statusList,
    filterInput,
    chipList,
    onClose,
    cargoNameList,
    getCargoList,
    deliveryTypeList,
    getDeliveryTypeList,
}) => {
    const { t } = useTranslation();
    const [selectedRegionChip, setSelectedRegionChip] = React.useState<any | null>(null);
    const [selectedCargoChip, setSelectedCargoChip] = React.useState<any | null>(null);
    const [selectedDeliveryTypeChip, setSelectedDeliveryTypeChip] = React.useState<any | null>(null);
    const [shoppingAmountChip, setShoppingAmountChip] = React.useState<number | null>(null);
    const shipmentFeeChip = null;
    const [selectedStatusChip, setSelectedStatusChip] = React.useState<any | null>(null);
    const [selectedDeliveryType, setSelectedDeliveryType] = React.useState<'' | undefined>('');
    const [selectedCargo, setSelectedCargo] = React.useState<'' | undefined>('');
    useEffect(() => {
        if (filterInput.cargoCompany > 0) {
            let cargo = cargoNameList.find((s: any) => {
                return s.id === filterInput.cargoCompany;
            });
            setSelectedCargo(cargo);
        }
        if (filterInput.deliveryType > 0) {
            let deliveryType = deliveryTypeList.find((s: any) => {
                return s.id === filterInput.deliveryType;
            });
            setSelectedDeliveryType(deliveryType);
        }
    }, []);

    const addOrUpdateChipList = (chipData: any, addingKeyword: string) => {
        const objWithIdIndex = chipList.findIndex((obj: any) => obj.label.includes(addingKeyword));
        if (objWithIdIndex > -1) {
            chipList[objWithIdIndex].label = addingKeyword.concat(' : ').concat(chipData.name);
        } else {
            let chipName = addingKeyword.concat(' : ').concat(chipData.name);
            chipList.push({ label: chipName, key: chipList.length + 1 });
        }
    };

    const setAllFiltersAndChips = async () => {
        let filters = Object.assign(filterInput);

        if (selectedRegionChip != null && selectedRegionChip?.id !== 0) {
            if (selectedRegionChip?.id !== -100) {
                addOrUpdateChipList(selectedRegionChip, 'Region');
            }
            filters.region = Number(selectedRegionChip.id);
        }
        if (selectedCargoChip != null && selectedCargoChip?.id !== 0 && selectedRegionChip?.id !== -100) {
            addOrUpdateChipList(selectedCargoChip, 'Cargo Company');
            filters.cargoCompany = Number(selectedCargoChip.id);
        }
        if (selectedDeliveryTypeChip != null && selectedDeliveryTypeChip?.id !== 0 && selectedRegionChip?.id !== -100) {
            addOrUpdateChipList(selectedDeliveryTypeChip, 'Delivery Type');
            filters.deliveryType = Number(selectedDeliveryTypeChip.id);
        }
        if (shoppingAmountChip != null) {
            addOrUpdateChipList({ id: 1, name: shoppingAmountChip }, 'Shopping Amount');
            filters.shoppingAmount = Number(shoppingAmountChip);
        }
        if (shipmentFeeChip != null) {
            addOrUpdateChipList({ id: 1, name: shipmentFeeChip }, 'Shipment Fee');
            filters.shipmentFee = Number(shipmentFeeChip);
        }

        if (selectedStatusChip != null) {
            addOrUpdateChipList(selectedStatusChip, 'Status');
            filters.status = Number(selectedStatusChip.id);
        }

        cargoShipmentList(filters);
    };

    return (
        <form
            className={CSF.filterForm}
            onSubmit={async (e: any) => {
                await setAllFiltersAndChips();
                e.preventDefault();
            }}
        >
            <div className={`commentFilterContainer ${CSF.filterContainer}`}>
                <Grid container spacing={1}>
                    <Box className={CSF.filterHeader}>
                        <SCUIGeneralDrawerHeader header={t('general.detailedFiltering')} onClose={onClose} />
                    </Box>
                    <Grid
                        className={CSF.filterFieldRegion}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="regionLabel">{t('general.region')}</InputLabel>
                            <Select
                                className={CSF.inputFilterRegion}
                                fullWidth
                                label={t('general.region')}
                                labelId="regionLabel"
                                id="regionSelect"
                                defaultValue={regionList.find((s: any) => {
                                    return s.id === filterInput.region;
                                })}
                                onChange={(event) => {
                                    let region: any = event.target.value;
                                    getCargoList(Number(region.id));
                                    getDeliveryTypeList(Number(region.id), selectedCargoChip?.id ?? -100);
                                    setSelectedRegionChip(region);
                                    setSelectedCargo(undefined);
                                    setSelectedCargoChip({ id: -100, name: 'All' });
                                    setSelectedDeliveryTypeChip({ id: -100, name: 'All' });
                                    setSelectedDeliveryType(undefined);
                                }}
                            >
                                {regionList &&
                                    regionList.map((region: any, index: number) => (
                                        <MenuItem
                                            id={region.id}
                                            value={region}
                                            key={index}
                                            className={CSF.filterRegionOption}
                                            data-region-id={region.id}
                                            data-region-name={region.name}
                                        >
                                            {region.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        className={CSF.filterFieldCargoCompany}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="cargoCompanyLabel">{t('general.cargoCompany')}</InputLabel>
                            <Select
                                className={CSF.inputFilterCargoCompany}
                                fullWidth
                                labelId="cargoCompanyLabel"
                                label={t('general.cargoCompany')}
                                id="cargoCompanySelect"
                                value={selectedCargo}
                                onChange={async (event) => {
                                    let cargoCompany: any = event.target.value;
                                    getDeliveryTypeList(Number(selectedRegionChip?.id), Number(cargoCompany.id));
                                    setSelectedCargoChip(cargoCompany);
                                    setSelectedCargo(cargoCompany);
                                    setSelectedDeliveryType(undefined);
                                    setSelectedDeliveryTypeChip({ id: -100, name: 'All' });
                                }}
                            >
                                {cargoNameList &&
                                    cargoNameList.map((cargo: any, index: number) => (
                                        <MenuItem
                                            id={cargo.id}
                                            value={cargo}
                                            key={index}
                                            className={CSF.filterCargoCompanyOption}
                                            data-cargo-company-id={cargo.id}
                                            data-cargo-company-name={cargo.name}
                                        >
                                            {cargo.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        className={CSF.filterFieldDeliveryType}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="deliveryTypeLabel">{t('general.deliveryType')}</InputLabel>
                            <Select
                                className={CSF.inputFilterDeliveryType}
                                fullWidth
                                labelId="deliveryTypeLabel"
                                label={t('general.deliveryType')}
                                id="deliveryTypeSelect"
                                value={selectedDeliveryType}
                                onChange={(event) => {
                                    let deliveryType: any = event.target.value;
                                    setSelectedDeliveryTypeChip(deliveryType);
                                    setSelectedDeliveryType(deliveryType);
                                }}
                            >
                                {deliveryTypeList && deliveryTypeList.length > 0 ? (
                                    deliveryTypeList.map((deliveryType: any, index: number) => (
                                        <MenuItem
                                            id={deliveryType.id}
                                            value={deliveryType}
                                            key={index}
                                            className={CSF.filterDeliveryTypeOption}
                                            data-delivery-type-id={deliveryType.id}
                                            data-delivery-type-name={deliveryType.name}
                                        >
                                            {deliveryType.name}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <div style={{ display: 'none' }}></div>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        className={CSF.filterFieldShoppingAmount}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <TextField
                            className={CSF.inputFilterShoppingAmount}
                            label={t('general.shoppingAmount')}
                            variant="outlined"
                            type="text"
                            id="shoppingAmountText"
                            fullWidth
                            defaultValue={filterInput && filterInput.shoppingAmount}
                            onChange={(event) => {
                                setShoppingAmountChip(Number(event.target.value));
                            }}
                        />
                    </Grid>

                    <Grid
                        className={CSF.filterFieldStatus}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="statusLabel">{t('general.status')}</InputLabel>
                            <Select
                                className={CSF.inputFilterStatus}
                                fullWidth
                                label={t('general.status')}
                                labelId="statusLabel"
                                id="statusSelect"
                                defaultValue={statusList.find((s: any) => {
                                    return s.id === filterInput.status;
                                })}
                                onChange={(event) => {
                                    let status: any = event.target.value;
                                    filterInput.status = status.id;
                                    setSelectedStatusChip(status);
                                }}
                            >
                                {statusList &&
                                    statusList.map((status: any, index: number) => (
                                        <MenuItem
                                            id={status.id}
                                            value={status}
                                            key={index}
                                            className={CSF.filterStatusOption}
                                            data-status-id={status.id}
                                            data-status-name={status.name}
                                        >
                                            {status.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        className={CSF.filterActionsBox}
                        style={{ position: 'absolute', bottom: 0, width: 380, marginBottom: '20px' }}
                    >
                        <SCUIButton
                            className={CSF.btnFilterSubmit}
                            text={t('general.list')}
                            type="primary"
                            sizeType="fixed"
                            buttonType="submit"
                            size={'m'}
                            fullwidth
                        />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
};
